(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sonagi-reviews-horizontal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sonagi-reviews-horizontal')) {
    customElements.define(
      'sonagi-reviews-horizontal',
      class extends HTMLElement {
        connectedCallback() {
          this.scroller = this.querySelector('.sonagi-reviews-horizontal__scroller');
          if (!this.scroller) return;

          if (this.dataset.initialized !== 'true') {
            this.dataset.initialized = 'true';
            this.shuffle();
            this.duplicate();
            this.sizeCards();
            this.classList.remove('is-pending');
          } else {
            this.sizeCards();
          }

          this.paused = false;
          this.isDragging = false;
          this.pxPerSecond = 38;
          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.inView = true;
          this.lastTime = 0;
          this.resumeDelay = 4500;

          this.bind();
          this.startAutoScroll();
        }

        disconnectedCallback() {
          this.stopAutoScroll();
          this.abort?.abort();
          this.io?.disconnect();
          clearTimeout(this.resumeTimer);
        }

        shuffle() {
          const items = Array.from(this.scroller.children).filter((el) => el.classList && el.classList.contains('r_c'));
          for (let i = items.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            this.scroller.appendChild(items[j]);
          }
        }

        duplicate() {
          const originals = Array.from(this.scroller.children).filter((el) => el.classList && el.classList.contains('r_c'));
          const fragment = document.createDocumentFragment();
          originals.forEach((item) => {
            const clone = item.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            fragment.appendChild(clone);
          });
          this.scroller.appendChild(fragment);
        }

        cardWidth() {
          const available = this.scroller.clientWidth || window.innerWidth;
          if (available < 750) {
            return Math.round(available * 0.82);
          }
          return 320;
        }

        sizeCards() {
          const width = this.cardWidth();
          this.scroller.querySelectorAll('.r_c').forEach((el) => {
            el.style.setProperty('display', 'flex', 'important');
            el.style.setProperty('flex', `0 0 ${width}px`, 'important');
            el.style.setProperty('width', `${width}px`, 'important');
            el.style.setProperty('min-width', `${width}px`, 'important');
            el.style.setProperty('max-width', `${width}px`, 'important');
            el.style.setProperty('overflow', 'hidden', 'important');
            el.style.setProperty('box-sizing', 'border-box', 'important');
          });
          this.scroller.querySelectorAll('.r_q').forEach((el) => {
            el.style.setProperty('white-space', 'normal', 'important');
            el.style.setProperty('overflow-wrap', 'anywhere', 'important');
            el.style.setProperty('word-break', 'break-word', 'important');
            el.style.setProperty('max-width', '100%', 'important');
          });
        }

        wrap() {
          const half = this.scroller.scrollWidth / 2;
          if (half <= 0) return;
          if (this.scroller.scrollLeft >= half) {
            this.scroller.scrollLeft -= half;
          } else if (this.scroller.scrollLeft < 0) {
            this.scroller.scrollLeft += half;
          }
        }

        tick = (now) => {
          if (!this.lastTime) this.lastTime = now;
          const dt = Math.min((now - this.lastTime) / 1000, 0.05);
          this.lastTime = now;

          if (!this.paused && this.inView && !this.reduceMotion && !this.isDragging) {
            this.scroller.scrollLeft += this.pxPerSecond * dt;
            this.wrap();
          }

          this.rafId = requestAnimationFrame(this.tick);
        };

        startAutoScroll() {
          this.stopAutoScroll();
          if (this.reduceMotion) return;
          this.lastTime = 0;
          this.rafId = requestAnimationFrame(this.tick);
        }

        stopAutoScroll() {
          if (this.rafId) cancelAnimationFrame(this.rafId);
          this.rafId = 0;
        }

        pauseTemporarily() {
          this.paused = true;
          this.classList.add('is-paused');
          clearTimeout(this.resumeTimer);
          this.resumeTimer = setTimeout(() => {
            if (!this.isDragging) {
              this.paused = false;
              this.classList.remove('is-paused');
              this.lastTime = 0;
            }
          }, this.resumeDelay);
        }

        bind() {
          this.abort?.abort();
          this.abort = new AbortController();
          const signal = this.abort.signal;
          const scroller = this.scroller;

          let isDown = false;
          let startX = 0;
          let startScroll = 0;
          let moved = false;

          scroller.addEventListener(
            'pointerdown',
            (event) => {
              if (event.pointerType === 'touch') {
                this.pauseTemporarily();
                return;
              }
              if (event.pointerType === 'mouse' && event.button !== 0) return;
              isDown = true;
              moved = false;
              startX = event.clientX;
              startScroll = scroller.scrollLeft;
              scroller.setPointerCapture(event.pointerId);
              this.pauseTemporarily();
            },
            { signal }
          );

          scroller.addEventListener(
            'pointermove',
            (event) => {
              if (!isDown) return;
              const dx = event.clientX - startX;
              if (Math.abs(dx) > 6) {
                moved = true;
                this.isDragging = true;
                this.classList.add('is-dragging');
              }
              if (this.isDragging) {
                scroller.scrollLeft = startScroll - dx;
                this.wrap();
              }
            },
            { signal }
          );

          const endDrag = (event) => {
            isDown = false;
            this.isDragging = false;
            this.classList.remove('is-dragging');
            if (moved) this.pauseTemporarily();
            try {
              scroller.releasePointerCapture(event.pointerId);
            } catch (error) {}
          };

          scroller.addEventListener('pointerup', endDrag, { signal });
          scroller.addEventListener('pointercancel', endDrag, { signal });

          scroller.addEventListener(
            'click',
            (event) => {
              if (!moved) return;
              event.preventDefault();
              event.stopPropagation();
            },
            { signal, capture: true }
          );

          scroller.addEventListener('wheel', () => this.pauseTemporarily(), { signal, passive: true });
          scroller.addEventListener('scroll', () => this.wrap(), { signal, passive: true });
          window.addEventListener(
            'resize',
            () => {
              this.sizeCards();
            },
            { signal }
          );

          document.addEventListener(
            'visibilitychange',
            () => {
              if (document.hidden) {
                this.paused = true;
                return;
              }
              this.paused = false;
              this.lastTime = 0;
            },
            { signal }
          );

          this.io?.disconnect();
          this.io = new IntersectionObserver(
            (entries) => {
              this.inView = entries.some((entry) => entry.isIntersecting);
              if (this.inView) this.lastTime = 0;
            },
            { threshold: 0.15 }
          );
          this.io.observe(this);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
